import React from 'react';
import { Navigate, Routes, Route, Outlet } from 'react-router';
import { ErrorLayout, Page, Suspense } from '@axiom/ui';

import { MagicLinkPage } from './pages/MagicLinkPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { SSOPage } from './pages/SSOPage';
import { EnterEmailPage } from './pages/EnterEmailPage';
import { Password } from './components/Password/Password';
import { SetPassword } from './components/SetPassword/SetPassword';
import { CheckEmailRedirect } from './components/CheckEmailRedirect/CheckEmailRedirect';
import { CheckYourEmail } from './components/CheckYourEmail/CheckYourEmail';
import { ExpiredLink } from './components/ExpiredLink/ExpiredLink';
import { Redirecter } from './components/Redirecter/Redirecter';
import { EnvUtil } from './utils/env-util';
import { TwoFactorAuthSetupPage } from './pages/TwoFactorAuthSetupPage';
import { TwoFactorAuthConfirmPage } from './pages/TwoFactorAuthConfirmPage';

export const Router = () => (
  <Routes>
    <Route
      element={
        <Suspense>
          <Page alignment="middle">
            <Outlet />
          </Page>
        </Suspense>
      }
    >
      <Route path="/">
        <Route path="email-token/:token" element={<MagicLinkPage />} />
        <Route path="client-login" element={<Navigate to="/" replace />} />
        <Route
          path="sign-up"
          element={<Redirecter url={EnvUtil.signUpUrl} />}
        />
        <Route path="" element={<EnterEmailPage />} />
        <Route path="link-expired" element={<ExpiredLink />} />
        <Route path="sso" element={<SSOPage />} />
        <Route path="terms-of-use" element={<TermsOfUsePage />} />
        <Route
          path="two-factor-register"
          element={<TwoFactorAuthSetupPage />}
        />
        <Route
          path="two-factor-confirm"
          element={<TwoFactorAuthConfirmPage />}
        />
        <Route path=":providedEmail">
          <Route path="" element={<CheckEmailRedirect />} />
          <Route path="password" element={<Password />} />
          <Route
            path="check-email"
            element={<CheckYourEmail key="check-email" />}
          />
          <Route
            path="forgot-password"
            element={<CheckYourEmail key="forgot-password" />}
          />
          <Route
            path="set-password"
            element={<SetPassword key="set-password" />}
          >
            <Route
              path=":token"
              element={<SetPassword key="set-password-token" />}
            />
          </Route>
        </Route>
        <Route
          path="not-found"
          element={
            <ErrorLayout
              errorMessage="Page not found."
              name="NOT_FOUND_ERROR_LAYOUT"
            />
          }
        />
        <Route path="oops" element={<ErrorLayout />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Route>
    </Route>
  </Routes>
);
